export default __webpack_public_path__ + "static/media/b5.37077b54.png";